
import list from './list'
const openPlatform = {
  path: 'openPlatform',
  component: resolve => require(['../../../../pages/modules/openPlatform'], resolve),
  redirect: 'openPlatform/list',
  children: [
    list
  ],
  meta: {
    requireAuth: true
  }
}

export default openPlatform
